import React from 'react';
// @ts-ignore
import EmbedComponent from 'components/corporatiu/Embed/Embed';
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
import styles from './memoriamarato.module.scss';
import type { EmbedData, MemoriaMaratoProps } from './MemoriaMarato.types';
import MemoriaMaratoEstatic from './MemoriaMaratoEstatic';

const Embed = EmbedComponent as React.ComponentType<{ data: string; className?: string }>;

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    title?: string;
    novaFinestra?: boolean;
    children: React.ReactNode;
}>;

const ABERTIS_IMG = 'https://statics.3cat.cat/recursos/marato/img/abertis-logo.jpg';

export default function MemoriaMarato({ anyMarato, memories = [] }: MemoriaMaratoProps) {
    let embed: EmbedData | undefined;

    if (memories && memories.length > 0) {
        const memoria = memories.find((m) => m.id === anyMarato);
        embed = memoria ? { html: memoria.html, abertis: memoria.abertis } : undefined;
    }

    if (anyMarato === '2014' || anyMarato === '2015') {
        return <MemoriaMaratoEstatic anyMarato={anyMarato} />;
    }

    if (!embed) return null;

    return (
        <div className={styles.wrapper}>
            <Embed data={embed.html} className={styles.embed} />

            {embed.abertis && (
                <aside className={styles.suport}>
                    <p>
                        <small>
                            <strong>Amb el suport de:</strong>
                        </small>
                    </p>
                    <Enllac href='https://www.fundacioabertis.org/' title='Fundació Abertis' novaFinestra={true}>
                        <Imatge src={ABERTIS_IMG} alt='Fundació Abertis' width={130} height={50} />
                    </Enllac>
                </aside>
            )}
        </div>
    );
}
